import { useEffect, useState } from 'react'
import isEmpty from 'lodash/isEmpty'
import uniqBy from 'lodash/uniqBy'
import orderBy from 'lodash/orderBy'

export default function useInfiniteScroll(apiFunction: any, apiParams: any) {
  // hasMore flag decides if we have any more net result.
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [data, setData] = useState<any>([])
  const [hasMore, setHasMore] = useState(true)

  useEffect(() => {
    setLoading(false)
    setError(false)
    setData([])
    setHasMore(true)
  }, [apiParams.projectId, apiParams.newNotesCount])

  useEffect(() => {
    setLoading(true)
    setError(false)
    if (hasMore) {
      apiFunction(apiParams).then((response: { data: { data: any } }) => {
        setLoading(false)
        if (
          !isEmpty(response) &&
          !isEmpty(response.data) &&
          !isEmpty(response.data.data)
        ) {
          setData((prevData: any) => {
            const cummulatedResult = [...prevData, ...response.data.data]
            cummulatedResult.map((item) => (item.id = parseInt(item.id)))
            const uniqResult = uniqBy(cummulatedResult, 'id')
            const orderedData = orderBy(uniqResult, 'id', ['desc'])
            return orderedData
          })
        } else if (isEmpty(response.data.data)) {
          setHasMore(false)
        }
      })
    }
  }, [apiParams.page, apiParams.projectId, hasMore, apiParams.newNotesCount])

  return { loading, error, data, hasMore }
}
